import { render, staticRenderFns } from "./InfoTextSummary.vue?vue&type=template&id=1e983a2e&"
import script from "./InfoTextSummary.vue?vue&type=script&lang=js&"
export * from "./InfoTextSummary.vue?vue&type=script&lang=js&"
import style0 from "./InfoTextSummary.vue?vue&type=style&index=0&id=1e983a2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports